var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('iframe',{staticStyle:{"width":"100%"},attrs:{"id":"code_iframe","src":"code.html","frameborder":"0","scrolling":"no"},on:{"load":_vm.load}})])}
var staticRenderFns = []

export { render, staticRenderFns }